export const FirebaseConfig = {
	"projectId": "quaumovil",
	"appId": "1:952793535086:web:c5da063d1df66457098c7f",
	"databaseURL": "https://quaumovil-default-rtdb.firebaseio.com",
	"storageBucket": "quaumovil.firebasestorage.app",
	"apiKey": "AIzaSyAU913N2LCsmaI9ErEk4Kq1-fp7P5z_b2g",
	"authDomain": "quaumovil.firebaseapp.com",
	"messagingSenderId": "952793535086",
	"measurementId": "G-SV5SYFYQTC",
	"projectNumber": "952793535086",
	"version": "2"
};